import React from 'react'

const Toped = () => {
    return (
        <section className="section">
            <h2>Toppers of this Examination</h2>
        </section>
    )
}

export default Toped
